/**
 * UI skin switch. `data-ui="ocean"` on <html> enables the Ocean Wave skin
 * (src/assets/css/ocean-theme.css). Purely visual: no handler or route differs.
 *
 * Default is ocean. Override with ?ui=classic / ?ui=ocean (persisted)
 * or REACT_APP_UI_THEME=classic.
 */
const KEY = 'dysgo-ui';

export type UiSkin = 'ocean' | 'classic';

export function resolveUiSkin(): UiSkin {
  try {
    const q = new URLSearchParams(window.location.search).get('ui');
    if (q === 'ocean' || q === 'classic') {
      localStorage.setItem(KEY, q);
      return q;
    }
    const stored = localStorage.getItem(KEY);
    if (stored === 'ocean' || stored === 'classic') return stored;
  } catch {
    /* storage unavailable */
  }
  return process.env.REACT_APP_UI_THEME === 'classic' ? 'classic' : 'ocean';
}

export function applyUiSkin(): UiSkin {
  const skin = resolveUiSkin();
  document.documentElement.setAttribute('data-ui', skin);
  return skin;
}

export function isOceanSkin(): boolean {
  return document.documentElement.getAttribute('data-ui') === 'ocean';
}
